import { getUserMailboxInfo } from 'owa-client-ids';
import substrateSuggestionsService from 'owa-substrate-people-suggestions/lib/services/substrateSuggestions';

export default async function getConferenceRoomDisplayName(roomEmail: string): Promise<any> {
    try {
        const parsedResponseText: any = await substrateSuggestionsService(
            getUserMailboxInfo().userIdentity,
            roomEmail /* queryString */,
            true /* includeDirectory */
        );

        if (
            parsedResponseText?.Groups?.[0]?.Suggestions?.[0] &&
            parsedResponseText.Groups[0].Suggestions[0].PeopleSubtype === 'Room' &&
            parsedResponseText.Groups[0].Suggestions[0].DisplayName
        ) {
            return Promise.resolve(parsedResponseText.Groups[0].Suggestions[0].DisplayName);
        }
        return Promise.resolve();
    } catch (e) {
        return Promise.reject();
    }
}
